import { useState, useEffect } from "react";
import axios from "axios";

const BASEURL =
  import.meta.env.VITE_REACT_APP_BACKEND_BASEURL ||
  import.meta.env.VITE_API_URL;

// Mapeamento dos nomes das colunas
const columnLabels = {
  Points: "Pontos",
  Serves: "Saque",
  Attacks: "Ataque",
  Reception: "Recepção",
  Blocks: "BK",
  Total: "Tot",
  PB: "PB",
  WL: "WL",
  PointsPercent: "Pts%",
  Points: "Pts",
  Errors: "Err",
  Blocks: "BK",
  PosPercent: "Pos%",
  ExcPercent: "Exc%",
};

const groupOrder = ["Points", "Serves", "Attacks", "Reception", "Blocks"];
const subgroupOrder = {
  Points: ["Total", "PB", "WL"],
  Serves: ["Total", "Points", "Errors"],
  Attacks: ["Total", "Points", "Blocks", "Errors", "PointsPercent"],
  Reception: ["Total", "Errors", "PosPercent", "ExcPercent"],
  Blocks: [], // valor simples
};

const groupSeparators = [
  // índices onde termina cada grupo
  subgroupOrder.Points.length,
  subgroupOrder.Points.length + subgroupOrder.Serves.length,
  subgroupOrder.Points.length +
    subgroupOrder.Serves.length +
    subgroupOrder.Reception.length,
  subgroupOrder.Points.length +
    subgroupOrder.Serves.length +
    subgroupOrder.Reception.length +
    subgroupOrder.Attacks.length,
];

function calcularTotais(athletes, dataObj) {
  const totais = {};

  // Inicializa totais
  groupOrder.forEach((group) => {
    totais[group] = {};
    if (subgroupOrder[group].length > 0) {
      subgroupOrder[group].forEach((sub) => {
        totais[group][sub] = 0;
      });
    } else {
      totais[group] = 0;
    }
  });

  // Acumula valores
  athletes.forEach((ath) => {
    const num = ath.number;
    const dados = dataObj[num] || {};

    // Points
    if (dados.Points) {
      if (dados.Points.Total)
        totais.Points.Total += Number(dados.Points.Total) || 0;
      // PB e WL não totalizar (deixe como "-")
    }

    // Serves
    if (dados.Serves) {
      if (dados.Serves.Total)
        totais.Serves.Total += Number(dados.Serves.Total) || 0;
      if (dados.Serves.Points)
        totais.Serves.Points += Number(dados.Serves.Points) || 0;
      if (dados.Serves.Errors)
        totais.Serves.Errors += Number(dados.Serves.Errors) || 0;
    }

    // Attacks
    if (dados.Attacks) {
      if (dados.Attacks.Total)
        totais.Attacks.Total += Number(dados.Attacks.Total) || 0;
      if (dados.Attacks.Points)
        totais.Attacks.Points += Number(dados.Attacks.Points) || 0;
      if (dados.Attacks.Blocks)
        totais.Attacks.Blocks += Number(dados.Attacks.Blocks) || 0;
      if (dados.Attacks.Errors)
        totais.Attacks.Errors += Number(dados.Attacks.Errors) || 0;
    }

    // Reception
    if (dados.Reception) {
      if (dados.Reception.Total)
        totais.Reception.Total += Number(dados.Reception.Total) || 0;
      if (dados.Reception.Errors)
        totais.Reception.Errors += Number(dados.Reception.Errors) || 0;
      // if (dados.Reception.PosPercent) {
      //   if (!totais.Reception.PosPercentArr)
      //     totais.Reception.PosPercentArr = [];
      //   totais.Reception.PosPercentArr.push(
      //     Number(dados.Reception.PosPercent) || 0
      //   );
      // }
      // if (dados.Reception.ExcPercent) {
      //   if (!totais.Reception.ExcPercentArr)
      //     totais.Reception.ExcPercentArr = [];
      //   totais.Reception.ExcPercentArr.push(
      //     Number(dados.Reception.ExcPercent) || 0
      //   );
      // }
    }

    // Blocks
    if (dados.Blocks !== undefined) {
      totais.Blocks += Number(dados.Blocks) || 0;
    }
  });

  // Pós-processamento para médias e percentuais
  // Ataque: Pts%
  totais.Attacks.PointsPercent =
    totais.Attacks.Total > 0
      ? ((totais.Attacks.Points / totais.Attacks.Total) * 100).toFixed(1)
      : "-";

  // Recepção: médias
  totais.Reception.PosPercent =
    totais.Reception.PosPercentArr && totais.Reception.PosPercentArr.length > 0
      ? (
          totais.Reception.PosPercentArr.reduce((a, b) => a + b, 0) /
          totais.Reception.PosPercentArr.length
        ).toFixed(1)
      : "-";
  totais.Reception.ExcPercent =
    totais.Reception.ExcPercentArr && totais.Reception.ExcPercentArr.length > 0
      ? (
          totais.Reception.ExcPercentArr.reduce((a, b) => a + b, 0) /
          totais.Reception.ExcPercentArr.length
        ).toFixed(1)
      : "-";

  // Points: PB e WL não totalizar
  totais.Points.PB = "-";
  totais.Points.WL = "-";

  // Remove arrays auxiliares
  delete totais.Reception.PosPercentArr;
  delete totais.Reception.ExcPercentArr;

  return totais;
}

function renderTotaisRow(totais) {
  return (
    <tr className="bg-yellow-100 font-bold">
      <td className="border border-gray-400 p-1 text-center">Σ</td>
      <td className="border border-gray-400 p-1 text-center">Total</td>
      {groupOrder.map((group, gIdx) =>
        subgroupOrder[group].length > 0 ? (
          subgroupOrder[group].map((sub, subIdx) => {
            let value =
              totais[group][sub] !== undefined ? totais[group][sub] : "-";
            // Formatação especial para Pts% e médias
            if (
              (group === "Attacks" && sub === "PointsPercent") ||
              (group === "Reception" &&
                (sub === "PosPercent" || sub === "ExcPercent"))
            ) {
              value = value !== "-" ? `${value}%` : "-";
            }
            const borderClass =
              subIdx === 0 && gIdx !== 0 ? "border-l-4 border-l-gray-500" : "";
            return (
              <td
                key={`totais-${group}-${sub}`}
                className={`border border-gray-400 p-1 text-center ${borderClass}`}
                style={{ minWidth: 32 }}
              >
                {value}
              </td>
            );
          })
        ) : (
          <td
            key={`totais-${group}`}
            className="border border-gray-400 p-1 text-center border-l-4 border-l-gray-500"
            style={{ minWidth: 32 }}
          >
            {totais[group]}
          </td>
        )
      )}
      <td className="border border-gray-400 p-1 text-center"></td>
    </tr>
  );
}

function ScoutAthletesTable({ teams = {}, partida, set, teamNames }) {
  const [homeData, setHomeData] = useState({});
  const [awayData, setAwayData] = useState({});
  const [loading, setLoading] = useState(false);

  // Função para substituir 0, null, undefined, "" ou "0" por hífen
  const formatValue = (val) => {
    if (
      val === 0 ||
      val === null ||
      val === undefined ||
      val === "" ||
      val === "0"
    )
      return "-";
    return val;
  };

  // Extrai atletas
  const homeAthletes = teams?.home || [];
  const awayAthletes = teams?.away || [];

  // Busca todos os dados dos atletas
  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      try {
        // Monta arrays de atletas para cada time
        const homeAthletesPayload = homeAthletes.map((ath) => ({
          number: ath.number,
          time: "*",
        }));
        const awayAthletesPayload = awayAthletes.map((ath) => ({
          number: ath.number,
          time: "a",
        }));
        // Chama o novo endpoint para cada time
        const [homeRes, awayRes] = await Promise.all([
          homeAthletesPayload.length > 0
            ? axios.post(`${BASEURL}/reports/athletes-report-set-multi`, {
                set: set ? parseInt(set) : undefined,
                partida,
                athletes: homeAthletesPayload,
              })
            : Promise.resolve({ data: {} }),
          awayAthletesPayload.length > 0
            ? axios.post(`${BASEURL}/reports/athletes-report-set-multi`, {
                set: set ? parseInt(set) : undefined,
                partida,
                athletes: awayAthletesPayload,
              })
            : Promise.resolve({ data: {} }),
        ]);
        setHomeData(homeRes.data || {});
        setAwayData(awayRes.data || {});
      } catch (err) {
        setHomeData({});
        setAwayData({});
      }
      setLoading(false);
    };
    if (partida && (homeAthletes.length > 0 || awayAthletes.length > 0)) {
      fetchAll();
    }
  }, [
    partida,
    set,
    JSON.stringify(teams?.home?.map((a) => a.number)),
    JSON.stringify(teams?.away?.map((a) => a.number)),
  ]);

  // Renderiza cabeçalho de grupos (ex: # | Nome | pts | ...)
  const renderGroupHeader = () => (
    <tr>
      <th
        rowSpan={2}
        className="border border-gray-400 p-1 bg-gray-100 text-center"
      >
        #
      </th>
      <th
        rowSpan={2}
        className="border border-gray-400 p-1 bg-gray-100 text-center"
      >
        Nome
      </th>
      {groupOrder.map((group, idx) =>
        subgroupOrder[group].length > 0 ? (
          <th
            key={group}
            colSpan={subgroupOrder[group].length}
            className={`border-t border-b border-gray-400 p-1 bg-gray-100 text-center border-l-4 ${
              idx === 0 ? "" : "border-l-gray-500"
            }`}
          >
            {columnLabels[group] || group}
          </th>
        ) : (
          <th
            key={group}
            rowSpan={2}
            className={`border-t border-b border-gray-400 p-1 bg-gray-100 text-center border-l-4 ${
              idx === 0 ? "" : "border-l-gray-500"
            }`}
          >
            {columnLabels[group] || group}
          </th>
        )
      )}
      <th
        rowSpan={2}
        className="border border-gray-400 p-1 bg-gray-100 text-center"
      >
        Nome
      </th>
    </tr>
  );

  // Renderiza subcabeçalho (ex: tot | PB | WL)
  const renderSubHeader = () => (
    <tr>
      {groupOrder.map((group, idx) =>
        subgroupOrder[group].length > 0
          ? subgroupOrder[group].map((sub, subIdx) => (
              <th
                key={group + sub}
                className={`border-b border-gray-400 p-1 bg-gray-50 text-center ${
                  subIdx === 0 && idx !== 0
                    ? "border-l-4 border-l-gray-500"
                    : ""
                }`}
              >
                {columnLabels[sub] || sub}
              </th>
            ))
          : null
      )}
    </tr>
  );

  // Atualize renderRows para receber showHeader e, se true, renderizar o nome do time, o cabeçalho de grupo e o subcabeçalho
  const renderRows = (dataObj, athletes, label, showHeader) => {
    // Ordena e filtra atletas válidos
    const sortedAthletes = [...athletes]
      .filter(
        (a) => a.number !== "" && a.number !== null && a.number !== undefined
      )
      .sort((a, b) => Number(a.number) - Number(b.number));
    const totais = calcularTotais(athletes, dataObj);
    return (
      <>
        <tr key={`group-title-${label}`}>
          <td colSpan={30} className="bg-grey-200 font-bold text-left p-2">
            {label}
          </td>
        </tr>
        {showHeader && renderGroupHeader()}
        {showHeader && renderSubHeader()}
        {sortedAthletes.map((ath, idx) => {
          const num = ath.number;
          const dados = dataObj[num] || {};
          return (
            <tr
              key={`${label}-${num}-${idx}`}
              className={idx % 2 === 1 ? "bg-gray-50" : ""}
            >
              <td className="border border-gray-400 p-1 text-center font-bold">
                {num}
              </td>
              <td className="border border-gray-400 p-1 text-center font-bold">
                {ath.name}
              </td>
              {groupOrder.map((group, gIdx) =>
                subgroupOrder[group].length > 0 ? (
                  subgroupOrder[group].map((sub, subIdx) => {
                    let value = dados[group]?.[sub];
                    if (
                      group === "Points" &&
                      sub === "WL" &&
                      (value === "0" || value === 0)
                    )
                      value = "-";
                    value = formatValue(value);
                    const isHyphen = value === "-";
                    const borderClass =
                      subIdx === 0 && gIdx !== 0
                        ? "border-l-4 border-l-gray-500"
                        : "";
                    return (
                      <td
                        key={`${label}-${num}-${group}-${sub}`}
                        className={`border border-gray-400 p-1 text-center ${borderClass} ${
                          isHyphen ? "text-[10px]" : ""
                        }`}
                        style={{ minWidth: 32 }}
                      >
                        {value}
                      </td>
                    );
                  })
                ) : (
                  <td
                    key={`${label}-${num}-${group}`}
                    className={`border border-gray-400 p-1 text-center border-l-4 border-l-gray-500`}
                    style={{ minWidth: 32 }}
                  >
                    {formatValue(dados[group])}
                  </td>
                )
              )}
              <td className="border border-gray-400 p-1 text-center font-bold">
                {ath.name}
              </td>
            </tr>
          );
        })}
        {renderTotaisRow(totais)}
      </>
    );
  };

  return (
    <div className="overflow-x-auto scout-athletes-table" style={{ background: '#fff' }}>
      {/* {set ? (
        <h2 className="text-xl font-semibold mb-2">Set {set}</h2>
      ) : (
        <h2 className="text-xl font-semibold mb-2">Partida</h2>
      )} */}

      {loading ? (
        <div className="p-4"></div>
      ) : (
        <table className="min-w-full border-collapse border border-gray-400 text-xs">
          <tbody>
            {renderRows(homeData, homeAthletes, teamNames?.home?.name, true)}
            {renderRows(awayData, awayAthletes, teamNames?.away?.name, true)}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ScoutAthletesTable;
